/**
 * Shopify integration visibility gate (VP-223 → hardening).
 *
 * Dostęp do modułu rozstrzyga BACKEND (`ShopifyAccessService`): super_admin,
 * whitelista testerów albo konto, które ma zainstalowany sklep (merchant z App
 * Store). Wynik jedzie do frontu jako `user.shopifyAccess` w `GET /api/auth/me`.
 *
 * Ten plik jest współdzielony z bundlem przeglądarki, dlatego NIE trzyma listy
 * e-maili testerów (leżała tu wcześniej i trafiała do JS każdego usera) —
 * front zna wyłącznie rozwiązaną flagę. Whitelist: `apps/api/modules/shopify/shopify-access-service.ts`.
 */

export type ShopifyAccessUser = {
  role?: string | null;
  email?: string | null;
  /** Rozwiązane serwerowo w `/api/auth/me` (whitelista LUB zainstalowany sklep). */
  shopifyAccess?: boolean | null;
};

/** super_admin zawsze; reszta wyłącznie z flagą rozwiązaną przez backend. */
export function canAccessShopifyIntegration(user: ShopifyAccessUser | null | undefined): boolean {
  if (!user) return false;
  if (user.role === "super_admin") return true;
  return user.shopifyAccess === true;
}
